export enum ProcessStatusEnum {
  NO_FILE = 0,
  INPUT_FILE_UPLOADED = 1,
  PROCESSING_TOKENS = 2,
  PROCESSING_IMAGES = 3,
  READY = 4,
  ERROR = 5,
}

export enum FileStatusEnum { NOT_EXIST = 0, AVAILABLE = 1 }

export enum BulkPaymentValidationErrorTypeEnum {
  INVALID_AMOUNT_COLUMN = 0,
  EMPTY_CLIENT_ID = 1,
  INVALID_REFERENCE_COLUMN = 2,
  INVALID_DATE_COLUMN = 3,
  INVALID_EXTENDED_REFERENCE_COLUMN = 4,
  INVALID_DESCRIPTION_COLUMN = 5,
}

export interface GetStatusResponse {
  processStatus: ProcessStatusEnum;
  currentTokensCount: number;
  currentImagesCount: number;
  totalCount: number;
  qrCodesStatus: FileStatusEnum;
  qrImagesStatus: FileStatusEnum;
  generateImages: boolean;
}

export interface ErrorLinesDto {
  errorType: BulkPaymentValidationErrorTypeEnum;
  lineNumber: number;
}

export interface CancelResponse { success: boolean; message: string; }
export interface ProcessFileResponse extends CancelResponse { name: string; }
export interface UploadFileResponse extends ProcessFileResponse { errorLines: ErrorLinesDto[]; }
export interface ProcessFileRequest { generateImages: boolean; }
